var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.dataItem.inEdit)?_c('td',{class:_vm.className},[_vm._v(_vm._s(_vm.dataItem[_vm.field]))]):_c('td',[_c('dropdownlist',{attrs:{"data-items":_vm.sifrantData,"text-field":'naziv',"value":_vm.selectedValue},on:{"change":_vm.change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }